import { type DeliveryClass } from '@hooks-api/types/dataModel/shipping'
import { useMemo } from 'react'
import { type PlatformType } from './store-map'
import { useFpB2bCartService } from './use-fp-b2b-cart-service'

export const useFpB2bDeliveryClassList = (campaignId: number | null, platform: PlatformType): DeliveryClass[] => {
  const { items } = useFpB2bCartService(campaignId, platform)

  return useMemo(() => {
    const dedupeDeliveryClassList = new Set<DeliveryClass>()
    items.forEach((item) => {
      if (item.delivery_class) {
        dedupeDeliveryClassList.add(item.delivery_class)
      }
    })
    return Array.from(dedupeDeliveryClassList)
  }, [items])
}
